export class PurchaseUnit {
  description: string;
  amount: {
    currency_code: string;
    value: number;
  }
  constructor() {
    this.description = '';
    this.amount = {
      currency_code: '',
      value: 0
    }
  }
}